import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { propType } from 'graphql-anywhere'
import { propOr } from 'ramda'
import classnames from 'classnames'

import { TARGET_TYPES, UUID_SLUG, AUTOPLAY_TRAILER_DELAY_S } from '../../constants'
import { getDetailsUrl } from '../../lib/utils'
import AutoplayTrailerStream from '../autoplay-trailer/autoplay-trailer-stream'
import HIGHLIGHTED_CONTENT_FRAGMENT from '../../../graphql/fragments/highlighted-content.gql'

import TileSlide from '../tile-slide'
import Button from '../button'
import styles from './highlighted-content.css'

/*
* HighlightedContentComponent on logged out home page
*/

function HighlightedContentComponent({ highlightedContent }) {
  const [showItemIndex, setShowItemIndex] = useState(0)
  const handleShowItemIndex = (showItem) => {
    setShowItemIndex(showItem)
  }
  const showContentItem = highlightedContent.tiles?.[showItemIndex]?.contentItem

  const cta = propOr({}, 'cta', highlightedContent)
  const ctaType = propOr('', 'type', cta)
  const ctaTarget = propOr('', 'target', cta)
  const ctaText = propOr('', 'text', cta)
  let navLinkTo = ctaTarget
  if (ctaType === TARGET_TYPES.SCREEN_ID) {
    navLinkTo = `/${UUID_SLUG}/${ctaTarget}`
  } else if (ctaType === TARGET_TYPES.SHOWPAGE) {
    navLinkTo = getDetailsUrl(showContentItem)
  }

  const isRental = showContentItem?.isRental && ctaType === TARGET_TYPES.SHOWPAGE
  const disableClickImageNavigation = ctaType === TARGET_TYPES.EXTERNAL_URL
  const trailerId = highlightedContent.tiles[0]?.contentItem?.__typename === 'VideoExtra' ? highlightedContent.tiles[0]?.contentItem?.id : null
  const videoContent = {
    id: trailerId,
    delaySeconds: AUTOPLAY_TRAILER_DELAY_S
  }
  const videoImage = highlightedContent.tiles[0]?.image

  return (
    <div className={classnames(styles.container, {
      [styles.isTrailerLayout]: trailerId
    })}
    >
      <div className={classnames(styles.highlightedContentWrapper, {
        [styles.isTrailerLayout]: trailerId
      })}
      >
        <div className={classnames(styles.tileSlideWrapper, {
          [styles.isTrailerLayout]: trailerId
        })}
        >
          {trailerId ? <AutoplayTrailerStream content={videoContent} image={videoImage} inHighlightedContent />
            : <TileSlide tiles={highlightedContent.tiles} handleChange={handleShowItemIndex} disableClickNavigation={disableClickImageNavigation} />}
        </div>

        <div className={classnames(styles.infoWrapper, {
          [styles.isTrailerLayout]: trailerId
        })}
        >
          <div className={styles.header}>
            {highlightedContent.header}
          </div>
          <div className={styles.description}>
            {highlightedContent.description}
          </div>
          {ctaType && (
            ctaType === TARGET_TYPES.EXTERNAL_URL ? (
              <a
                href={ctaTarget}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  className={styles.cta}
                  text={ctaText}
                  isRental={isRental}
                />
              </a>
            ) : (
              <NavLink to={navLinkTo}>
                <Button
                  className={styles.cta}
                  text={ctaText}
                  isRental={isRental}
                />
              </NavLink>
            )
          )}
        </div>
      </div>
    </div>
  )
}

HighlightedContentComponent.propTypes = {
  highlightedContent: propType(HIGHLIGHTED_CONTENT_FRAGMENT).isRequired
}

export default HighlightedContentComponent
